/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SnapshotId } from "../../commons/types/SnapshotId";
import { SheetId } from "../../commons/types/SheetId";
import { SnapshotSummary } from "./SnapshotSummary";
import { UserId } from "../../commons/types/UserId";
export const Snapshot = core.serialization.object({
    id: SnapshotId,
    sheetId: SheetId,
    label: core.serialization.string().optional(),
    threadId: core.serialization.string().optional(),
    summary: SnapshotSummary.optional(),
    createdAt: core.serialization.date(),
    createdBy: UserId,
});
